import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class NumberUtils {

    public properties: any;
    public uomLists: any = { Thousand: { shortname: 'K' }, Million: { shortname: 'M' }, Billion: { shortname: 'B' }, Trillion: { shortname: 'T' } };
    public static get MILLION(): number { return 1000000.0 };
    public static get BILLION(): number { return 1000000000.0 };
    public static get LAKHS(): number { return 100000.0 };
    public static get THOUSANDS(): number { return 1000.0 };

    constructor() {
        // try {
        //   this.properties = { BI_BASE_URL: '/bi', EPMS_BASE_URL: '/home' };
        //   this.getUom().then(function (success: any) {
        //   });
        // } catch (e) {
        //   console.error(e);
        // }
    }

    public autoScale(value: any) {
        let suffix = '';
        try {
            let x: number = parseFloat(value);
            let opr: number = x > 0 ? 1 : -1;
            x = Math.abs(x);

            if (x > NumberUtils.BILLION) {
                value = x / (NumberUtils.BILLION);
                suffix = this.uomLists.Billion.shortname;
            } else if (x > NumberUtils.MILLION) {
                value = x / (NumberUtils.MILLION);
                suffix = this.uomLists.Million.shortname;
            } else if (x > NumberUtils.LAKHS) {
                value = x / (NumberUtils.THOUSANDS);
                suffix = this.uomLists.Thousand.shortname;
            }

            value = opr == -1 ? -Math.abs(value) : value;
        } catch (e) { }
        return { value: value, suffix: suffix };
    }

    public autoFormat(x: any, cft?: any) {
        try {
            let val = this.autoScale(x);
            return this.numberWithCommas(val.value, cft) + " " + val.suffix;
        } catch (e) {
            return '';
        }
    }

    public numberWithCommas(val: any, format?: any): any {
        try {
            if (!Number.isNaN(val)) {
                let x: Number = Math.round(val * 100) / 100;

                let parts: any;
                if (format) {
                    parts = x.toFixed(format.pre).split(".");
                } else {
                    parts = x.toString().split(".");
                }

                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                return parts.join(".");
            }

        } catch (e) {

        }
        return 0;
    }

    public isNaN(obj) {
        try {
            return isNaN(Number(obj));
        } catch (e) {
            return true;
        }
    }


    checkDecimalPoints(event, dp) {
        let val = event.target.value.trim();
        let dec = val.split('.');
        let decimals = "";
        if (!(/^[-]?[0-9]+(?:\.[0-9]*)?$/.test(val))) {
            event.target.value = val.slice(0, -1);
            return;
        }
        else {
            if (dec.length > 1) {
                decimals = dec[1];
            }
            else {
                return;
            }
            if (val != "" && (decimals && decimals.length > dp)) {
                //console.log("Initial ", val);
                let f: any = parseFloat(val);
                let np = f.toFixed(dp);
                event.target.value = np;
                //console.log("Changed ", event.target.value);
            }
        }
    }

    get symbols() {
        let self = this;
        try {
            let symbols = [];

            if (self.uomLists.Thousand.shortname) {
                symbols.push(' ' + self.uomLists.Thousand.shortname.charAt(0));
            } else {
                symbols.push(' k');
            }

            if (self.uomLists.Million.shortname) {
                symbols.push(' ' + self.uomLists.Million.shortname.charAt(0));
            } else {
                symbols.push(' M');
            }

            if (self.uomLists.Billion.shortname) {
                symbols.push(' ' + self.uomLists.Billion.shortname.charAt(0));
            } else {
                symbols.push(' B');
            }

            if (self.uomLists.Trillion.shortname) {
                symbols.push(' ' + self.uomLists.Trillion.shortname.charAt(0));
            } else {
                symbols.push(' T');
            }

            return symbols;
        } catch (e) {
            return ["k", "M", "G", "T", "P", "E"];
        }
    }

    get(key: any) {
        return this.properties && this.properties[key] ? this.properties[key] : undefined;
    }

    public getUom() {
        let self = this;

        //if (this.uomLists) {
        return new Promise((observer, reject: any) => {
            observer(self.uomLists)
        });
        //}
        // } else {
        //     return new Promise((observer, reject: any) => {
        //         let url: string;
        //         let https: any = [];
        //         url = this.get("BI_BASE_URL") + '/v1/ads/value_range';
        //         //console.log(url)
        //         this._httpClient.get(url).subscribe(res => {
        //             self.uomLists = res;
        //             observer(res);
        //         }, err => {
        //             //console.log(err);
        //             reject(err);
        //         });
        //     });
        // }

    }

}



// WEBPACK FOOTER //
// ./src/app/bi/common/service/number.utils.ts